function cov_a3zphqt0d() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeCostFilled.tsx";
  var hash = "1660272df605bcc6f004d73d6895cb4e1fa84b1f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeCostFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 56
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1660272df605bcc6f004d73d6895cb4e1fa84b1f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_a3zphqt0d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_a3zphqt0d();
var Icon = (cov_a3zphqt0d().s[0]++, {
  name: 'home-cost-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 9.3V20.7793C22 21.3316 21.5523 21.7793 21 21.7793H3C2.44772 21.7793 2 21.3316 2 20.7793V9.3C2 8.97369 2.15921 8.6679 2.42654 8.48077L11.4265 2.18077C11.7709 1.93974 12.2291 1.93974 12.5735 2.18077L21.5735 8.48077C21.8408 8.6679 22 8.97369 22 9.3ZM12.7839 17.612V16.5975C14.474 16.3638 15.0973 15.2903 15.108 14.2784C15.108 12.6114 13.5449 12.2253 12.2873 11.9147L12.2838 11.9139C11.4565 11.711 10.7472 11.532 10.7472 11.0663C10.7472 10.6006 11.203 10.2873 11.8804 10.2873C12.2664 10.2807 12.6499 10.348 13.0088 10.4854C13.3677 10.6228 13.6948 10.8275 13.9712 11.0877C13.984 11.0999 13.9994 11.1094 14.0163 11.1154C14.0331 11.1214 14.0512 11.1239 14.0691 11.1227C14.0871 11.1215 14.1045 11.1166 14.1204 11.1083C14.1362 11.1001 14.1501 11.0887 14.161 11.0749L14.9023 10.1332C14.9206 10.1098 14.9295 10.0808 14.9274 10.0515C14.9252 10.0222 14.9122 9.99469 14.8907 9.97396C14.3173 9.4386 13.584 9.0909 12.7946 8.98004V7.95273C12.7946 7.90732 12.7759 7.86377 12.7426 7.83167C12.7094 7.79956 12.6643 7.78151 12.6172 7.78151H11.3759C11.3288 7.78151 11.2837 7.79956 11.2505 7.83167C11.2172 7.86377 11.1985 7.90732 11.1985 7.95273V8.99716C9.95536 9.24286 9.1396 10.0656 9.1396 11.1673C9.1396 12.7759 10.6514 13.1458 11.8662 13.442C12.7431 13.656 13.4995 13.8418 13.4995 14.4008C13.4995 14.8246 13.1404 15.2774 12.1313 15.2774C11.7028 15.2757 11.2793 15.1887 10.8872 15.0218C10.4951 14.8549 10.1429 14.6117 9.8525 14.3075C9.83986 14.2943 9.82435 14.284 9.80709 14.2773C9.78983 14.2706 9.77126 14.2677 9.75269 14.2688C9.73412 14.2698 9.71602 14.2749 9.69971 14.2835C9.68339 14.2921 9.66926 14.3041 9.65832 14.3186L8.90551 15.3014C8.88817 15.3246 8.87982 15.3529 8.88192 15.3813C8.88403 15.4098 8.89646 15.4367 8.91704 15.4572C9.5289 16.0571 10.3257 16.4494 11.1879 16.5753V17.612C11.1879 17.6574 11.2066 17.701 11.2398 17.7331C11.2731 17.7652 11.3182 17.7832 11.3652 17.7832H12.6066C12.6536 17.7832 12.6987 17.7652 12.732 17.7331C12.7652 17.701 12.7839 17.6574 12.7839 17.612Z\" fill=\"currentColor\"/>"
});
export default Icon;